import * as React from "react";
import VopHeader from "components/vop_header";

import VopDocument from "components/vop_document";

import VopFooter from "components/vop_footer";

import HomeHeader from "components/HomeHeader"

export default class APIDocument extends React.Component {
  componentDidMount() {
    document.title = '京东VOP开放平台-文档中心';
  }

  render() {
    return (
      <React.Fragment>
        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div
                className="jdw-widget"
                data-name="vop_header"
                data-version="7.0.0"
              >
                <VopHeader flow contentWidth="1200px">
                    <HomeHeader />
                </VopHeader>
              </div>
            </div>
          </div>
        </div>

        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div
                className="jdw-widget"
                data-name="vop_document"
                data-version="7.0.0"
              >
                <VopDocument docType="api"/>
              </div>
            </div>
          </div>
        </div>

        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div
                className="jdw-widget"
                data-name="vop_footer"
                data-version="2.0.0"
              >
                <VopFooter />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
